import React, { useState } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import axios from "axios";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaGithub,
  FaFacebook,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import { SiGnusocial, SiNextdotjs } from "react-icons/si";
import SendMsgBtn from "../components/buttons/SendMsgBtn";

const Contact = ({ theme }) => {
  let [username, setUsername] = useState("");
  let [email, setEmail] = useState("");
  let [enquiry, setEnquiry] = useState("");
  let [message, setMessage] = useState("");
  let [errMessage, setErrMessage] = useState("");
  let [successMessage, setSuccessMessage] = useState("");

  const emailValidation = (email) => {
    return String(email)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };

  const handleSendMsg = (e) => {
    e.preventDefault();

    if (username === "") {
      setErrMessage("Please provide your Name!");
    } else if (email === "") {
      setErrMessage("Please provide your Email!");
    } else if (!emailValidation(email)) {
      setErrMessage("Please provide a Valid Email");
    } else if (enquiry === "") {
      setErrMessage("Provide your enquiry reasons!");
    } else if (message === "") {
      setErrMessage("Provide the Messages!");
    } else {
      axios.post("https://getform.io/f/fb9d1b74-60fe-4058-98a2-f9b4b1032ea5", {
        title: "resume",
        name: username,
        email: email,
        enquiry: enquiry,
        message: message,
      });
      setSuccessMessage(
        `Hello dear ${username}. Glad to received your message successfully. Your enquiry details will send to you by your email at ${email}. Thank you for giving your valuable time.`
      );
      setUsername("");
      setEmail("");
      setEnquiry("");
      setMessage("");
    }
  };
  return (
    <div
      className={`${
        theme === "dark" ? "text-darkTextColor" : "text-lightTextColor"
      } w-full h-auto py-10`}
    >
      <Helmet>
        <title>Contact | Noor Mohammad</title>
      </Helmet>
      <div className="max-w-6xl mx-auto flex flex-col gap-20">
        <div className="w-full flex justify-center">
          <button
            className={`${
              theme === "dark"
                ? "border-darkTextColor text-white"
                : "border-lightTextColor text-black"
            } w-72 h-20 uppercase border-4 font-bold text-3xl tracking-[1px] relative font-bodyFont`}
          >
            Get In Touch
            <span
              className={`${
                theme === "dark"
                  ? "border-t-darkTextColor"
                  : "border-t-lightTextColor"
              } w-0 h-0 border border-l-[8px] border-t-[12px] border-r-[8px] border-transparent  absolute -bottom-4 left-8`}
            ></span>
          </button>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8 xl:gap-4 place-items-center">
          {/* ======================= Address start here ========================= */}
          <div className="w-[240px] h-[140px] flex flex-col gap-3 group">
            <div className="flex flex-col">
              <FaMapMarkerAlt
                className={`${
                  theme === "dark"
                    ? "text-blue-700 group-hover:text-lightTextDesignColor"
                    : "text-lightTextDesignColor group-hover:text-blue-700"
                } text-4xl mb-2 duration-300`}
              />
              <h3
                className={`${
                  theme === "dark"
                    ? "border-b-blue-700"
                    : "border-b-lightTextDesignColor"
                } text-2xl font-semibold tracking-wide border-b-[1px]`}
              >
                Address
              </h3>
            </div>
            <div className="text-base tracking-wide">
              <p>Mirpur-1, RAA </p>
              <p>Dhaka, Bangladesh</p>
            </div>
          </div>
          {/* ======================= Address Phone here ========================= */}
          <div className="w-[240px] h-[140px] flex flex-col gap-3 group">
            <div>
              <FaPhoneAlt
                className={`${
                  theme === "dark"
                    ? "text-blue-700 group-hover:text-lightTextDesignColor"
                    : "text-lightTextDesignColor group-hover:text-blue-700"
                } text-4xl mb-2`}
              />
              <h3
                className={`${
                  theme === "dark"
                    ? "border-b-blue-700"
                    : "border-b-lightTextDesignColor"
                } text-2xl font-semibold tracking-wide border-b-[1px]`}
              >
                Phone Number
              </h3>
            </div>
            <div className="text-base tracking-wide">
              <p>+88 01817986903</p>
            </div>
          </div>
          {/* ======================= Address Email here ========================= */}
          <div className="w-[240px] h-[140px] flex flex-col gap-3 group">
            <div>
              <FaEnvelope
                className={`${
                  theme === "dark"
                    ? "text-blue-700 group-hover:text-lightTextDesignColor"
                    : "text-lightTextDesignColor group-hover:text-blue-700"
                } text-4xl mb-2`}
              />
              <h3
                className={`${
                  theme === "dark"
                    ? "border-b-blue-700"
                    : "border-b-lightTextDesignColor"
                } text-2xl font-semibold tracking-wide border-b-[1px]`}
              >
                Email
              </h3>
            </div>
            <div className="text-base tracking-wide">
              <p>noor@arogga.com.bd</p>
              <p>noorjsdivs@gmail.com </p>
              <p>reactjsbd@gmail.com</p>
              <p>reactbd@proton.me</p>
            </div>
          </div>
          {/* ======================= Address Social here ======================== */}
          <div className="w-[240px] h-[140px] flex flex-col gap-3 group">
            <div>
              <SiGnusocial
                className={`${
                  theme === "dark"
                    ? "text-blue-700 group-hover:text-lightTextDesignColor"
                    : "text-lightTextDesignColor group-hover:text-blue-700"
                } text-4xl mb-2`}
              />
              <h3
                className={`${
                  theme === "dark"
                    ? "border-b-blue-700"
                    : "border-b-lightTextDesignColor"
                } text-2xl font-semibold tracking-wide border-b-[1px]`}
              >
                Medium
              </h3>
            </div>
            <div className="text-base tracking-wide flex gap-2">
              <a
                href="https://github.com/noorjsdivs"
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className={`${
                    theme === "dark"
                      ? "border-blue-700 hover:bg-blue-700 hover:text-black"
                      : "border-lightTextDesignColor hover:bg-lightTextDesignColor hover:text-white"
                  } w-8 h-8 border-[1px] rounded-full inline-flex justify-center items-center hover:cursor-pointer duration-300`}
                >
                  <FaGithub />
                </span>
              </a>
              <a
                href="https://www.youtube.com/@reactjsBD"
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className={`${
                    theme === "dark"
                      ? "border-blue-700 hover:bg-blue-700 hover:text-black"
                      : "border-lightTextDesignColor hover:bg-lightTextDesignColor hover:text-white"
                  } w-8 h-8 border-[1px] rounded-full inline-flex justify-center items-center hover:cursor-pointer duration-300`}
                >
                  <FaYoutube />
                </span>
              </a>
              <a
                href="https://www.linkedin.com/in/noor-mohammad-ab2245193/"
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className={`${
                    theme === "dark"
                      ? "border-blue-700 hover:bg-blue-700 hover:text-black"
                      : "border-lightTextDesignColor hover:bg-lightTextDesignColor hover:text-white"
                  } w-8 h-8 border-[1px] rounded-full inline-flex justify-center items-center hover:cursor-pointer duration-300`}
                >
                  <FaLinkedin />
                </span>
              </a>
              <a
                href="https://www.facebook.com/Noorlalu143/"
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className={`${
                    theme === "dark"
                      ? "border-blue-700 hover:bg-blue-700 hover:text-black"
                      : "border-lightTextDesignColor hover:bg-lightTextDesignColor hover:text-white"
                  } w-8 h-8 border-[1px] rounded-full inline-flex justify-center items-center hover:cursor-pointer duration-300`}
                >
                  <FaFacebook />
                </span>
              </a>
              <a
                href="https://vercel.com/noorjsdivs"
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className={`${
                    theme === "dark"
                      ? "border-blue-700 hover:bg-blue-700 hover:text-black"
                      : "border-lightTextDesignColor hover:bg-lightTextDesignColor hover:text-white"
                  } w-8 h-8 border-[1px] rounded-full inline-flex justify-center items-center hover:cursor-pointer duration-300`}
                >
                  <SiNextdotjs />
                </span>
              </a>
            </div>
          </div>
        </div>
        {/* ===================== Get in Touch form start here =================== */}
        <div className="w-full px-4">
          <h3
            className={`${
              theme === "dark"
                ? "border-b-blue-700"
                : "border-b-lightTextDesignColor"
            } text-3xl w-72 font-semibold tracking-wide border-b-[1px]`}
          >
            Get In Touch
          </h3>
          <div className="w-full flex justify-center items-center">
            <form
              id="form"
              action="https://getform.io/f/a9b602ef-a1c7-4128-a2d1-b46065b89f54"
              method="POST"
              className={`mt-10 py-20 px-10 w-full z-10 border border-darkLineColor border-opacity-50 rounded-sm flex flex-col gap-6`}
            >
              {successMessage ? (
                <div className="w-full px-10 text-lg tracking-wide text-green-700">
                  <motion.p
                    initial={{ x: 100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{
                      delay: 0.2,
                      x: { type: "spring", stiffness: 60 },
                      opacity: { duration: 1 },
                      ease: "easeIn",
                      duration: 1,
                    }}
                  >
                    {successMessage}
                  </motion.p>
                </div>
              ) : (
                <>
                  {errMessage && (
                    <div
                      className={`${
                        theme === "dark" ? "border-red-700" : "border-pink-900"
                      } border py-2 `}
                    >
                      <h5 className="w-full text-red-400  text-center text-base font-bold animate-bounce tracking-wider">
                        {errMessage}
                      </h5>
                    </div>
                  )}
                  <div className="flex flex-col md:flex-row justify-between gap-6 md:gap-10 w-full">
                    <input
                      onChange={(e) => setUsername(e.target.value)}
                      value={username}
                      className={`${
                        theme === "dark"
                          ? "bg-black border-blue-700 text-darkTextDesignColor "
                          : "bg-gray-50 border-lightTextDesignColor text-darkBgColor"
                      } rounded-sm w-full border p-3 text-xl font-bodyFont placeholder:text-[18px] placeholder:text-gray-500 outline-none`}
                      type="text"
                      placeholder="Enter your Full name"
                    />
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      className={`${
                        theme === "dark"
                          ? "bg-black border-blue-700 text-darkTextDesignColor "
                          : "bg-gray-50 border-lightTextDesignColor text-darkBgColor"
                      } rounded-sm w-full border p-3 text-xl font-bodyFont placeholder:text-[18px] placeholder:text-gray-500 outline-none`}
                      type="email"
                      placeholder="Email"
                    />
                  </div>
                  <div className="flex flex-row justify-between gap-10 w-full relative">
                    <input
                      onChange={(e) => setEnquiry(e.target.value)}
                      value={enquiry}
                      className={`${
                        theme === "dark"
                          ? "bg-black border-blue-700 text-darkTextDesignColor "
                          : "bg-gray-50 border-lightTextDesignColor text-darkBgColor"
                      } rounded-sm w-full border p-3 text-xl font-bodyFont placeholder:text-[18px] placeholder:text-gray-500 outline-none`}
                      type="text"
                      placeholder="Your enquiry about"
                    />
                  </div>
                  <div className="flex flex-row justify-between gap-10 w-full relative">
                    <textarea
                      onChange={(e) => setMessage(e.target.value)}
                      value={message}
                      rows="6"
                      className={`${
                        theme === "dark"
                          ? "bg-black border-blue-700 text-darkTextDesignColor "
                          : "bg-gray-50 border-lightTextDesignColor text-darkBgColor"
                      } rounded-sm w-full border p-3 text-xl font-bodyFont placeholder:text-[18px] placeholder:text-gray-500 outline-none`}
                      type="text"
                      placeholder="Message"
                    />
                  </div>
                  <div
                    onClick={handleSendMsg}
                    className="w-full flex justify-center mt-4"
                  >
                    <SendMsgBtn theme={theme} />
                  </div>
                  <>
                    {errMessage && (
                      <p
                        className={`${
                          theme === "dark"
                            ? "text-darkTextDesignColor"
                            : "text-black"
                        } w-full border-[1px] border-yellow-500 py-1 px-4`}
                      >
                        One or more fields have an error. Please check and try
                        again.
                      </p>
                    )}
                  </>
                </>
              )}
            </form>
          </div>
        </div>
        {/* ===================== Get in Touch form end   here =================== */}
      </div>
    </div>
  );
};

export default Contact;
